module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAaVBMVEUAAACqqqqSkpKfn5+ZmZmhoaGXl5ebm5uZmZmampqampqXl5ebm5uampqYmJiZmZmZmZmZmZmampqampqampqZmZmampqampqbm5uampqampqZmZmampqampqampqampqampqampqampqeGKAxAAAAI3RSTlMABgcIDxMbISgwNTY4U1dzdoKIn6etr8XGx9fY29zg4fP4+lYRct4AAABUSURBVAjXY2DABPzyUlLyAnCuDDMDA6MshC0pp6SoAASKSnKSID6PCERcmIcBO1eQnU0IiSvCySFGNJeXlYUPxuUShZgswg2mmMSlpYBAWoIZw/UAkiQGEWAmAyQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/found/icon-reply-delete.png
// module id = dgkp
// module chunks = 0